module.exports = __webpack_public_path__ + "static/tetleys-invest-yutongs-e160aacdefc78f010cd711d6182f102e.jpg";